import AiCryptoTokenEconomy from "../pages/blog/AiCryptoTokenEconomy";
import AiSaas2025 from "../pages/blog/AiSaas2025";
import DevBlogsIntro from "../pages/blog/DevBlogsIntro";
import FromDeveloperToStudio from "../pages/blog/FromDeveloperToStudio";
import OptimusFaceResurrection from "../pages/blog/OptimusFaceResurrection";
import BuildingTelegramMediaSkillOpenclaw from "../pages/blog/BuildingTelegramMediaSkillOpenclaw";
import BuildingToolForgeMVP from "../pages/blog/BuildingToolForgeMVP";
import BuildingTalkingBookPublisherDashboard from "../pages/blog/BuildingTalkingBookPublisherDashboard";

/**
 * Blog post registry.
 * To add a new post:
 *   1. Create a component in src/pages/blog/YourPost.js
 *   2. Import it here
 *   3. Add an entry to this array
 *
 * Posts are displayed in the order they appear (newest first).
 *
 * Categories: "Insights" (default), "Developer Blogs"
 */
const blogPosts = [
  {
    slug: "building-talkingbook-publisher-dashboard",
    title: "Building the TalkingBook Publisher Dashboard: 65+ Metrics Across 8 Categories",
    description: "How I built a comprehensive analytics dashboard for AI‑powered interactive stories, tracking 65+ metrics across eight categories—core performance, emotional engagement, chat behavior, character intelligence, audience segments, retention, viral signals, and predictive intelligence. A walkthrough of the React, Recharts, and glassmorphism stack, the challenges of placeholder‑driven development, and the lessons learned from shipping a data‑rich interface before the backend exists.",
    tag: "Developer Blogs",
    category: "Developer Blogs",
    date: "February 2026",
    readTime: "8 min read",
    published: true,
    component: BuildingTalkingBookPublisherDashboard,
  },
  {
    slug: "building-toolforge-mvp",
    title: "Building ToolForge: 8 Client‑Side Utility Tools in 24 Hours",
    description:
      "How I built a complete utility website with eight client‑side tools—image compression, resizing, format conversion, word counting, case conversion, JSON formatting, Base64 encoding, and UUID generation—in less than a day. A walkthrough of the Next.js 15, React 19, and TypeScript stack, the design decisions, and the lessons learned from shipping a fully front‑end product.",
    tag: "Developer Blogs",
    category: "Developer Blogs",
    date: "February 2026",
    readTime: "9 min read",
    published: true,
    component: BuildingToolForgeMVP,
  },
  {
    slug: "building-telegram-media-skill-openclaw",
    title: "Building a Telegram Media Skill for OpenClaw: Adding Multi‑modal AI to Your Assistant",
    description:
      "How I built a Telegram media skill for OpenClaw that sends and receives files—images, videos, audio, documents—and processes them with multi‑modal AI. The skill integrates with a trading dashboard to analyze crypto chart screenshots and generate signals. A walkthrough of the architecture, challenges, and lessons learned.",
    tag: "Developer Blogs",
    category: "Developer Blogs",
    date: "February 2026",
    readTime: "8 min read",
    published: true,
    component: BuildingTelegramMediaSkillOpenclaw,
  },
  {
    slug: "optimus-face-resurrection",
    title: "From Catastrophe to Creation: The Optimus Face Resurrection",
    description:
      "A forensic recovery story — how we rebuilt an entire AI interface from session logs after catastrophic data loss, and the engineering lessons that emerged from the ashes.",
    tag: "Developer Blogs",
    category: "Developer Blogs",
    date: "February 2026",
    readTime: "10 min read",
    published: true,
    component: OptimusFaceResurrection,
  },
  {
    slug: "from-developer-to-studio",
    title:
      "From Developer to Studio: Why I Built Hayden Bulk Tech Labs",
    description:
      "The story of going from writing code inside other people's products to running a complete end-to-end development studio — and why the AI era has made this the best time in history for businesses to invest in technology-driven growth.",
    tag: "Developer Blogs",
    category: "Developer Blogs",
    date: "September 2025",
    readTime: "8 min read",
    published: true,
    component: FromDeveloperToStudio,
  },
  {
    slug: "ai-powered-digital-products-saas-2025",
    title: "How AI-Powered Digital Products Are Changing SaaS in 2025",
    description:
      "The SaaS industry is undergoing its most significant transformation since the shift to cloud. Here's how AI is reshaping architecture, agents are automating workflows, and why product-first teams are winning.",
    tag: "AI & SaaS",
    category: "Insights",
    date: "October 2025",
    readTime: "8 min read",
    published: true,
    component: AiSaas2025,
  },
  {
    slug: "introducing-developer-blogs",
    title: "Introducing Developer Blogs",
    description:
      "A new category dedicated to honest, unfiltered writing from the people who actually build things — real observations, lessons, and ideas from the daily work of shipping production software.",
    tag: "Developer Blogs",
    category: "Developer Blogs",
    date: "January 2026",
    readTime: "4 min read",
    published: true,
    component: DevBlogsIntro,
  },
  {
    slug: "ai-recreated-crypto-token-economy",
    title:
      "AI Has Quietly Recreated Crypto's Token Economy — Just Without the Blockchain",
    description:
      "AI companies have independently reinvented the same tokenized compute model that crypto pioneered — metered value, scarce resources, priority lanes. It's capitalism finding the same answer twice.",
    tag: "AI & Crypto",
    category: "Insights",
    date: "February 2026",
    readTime: "12 min read",
    published: true,
    component: AiCryptoTokenEconomy,
  },
];

export default blogPosts;
